/* eslint-disable */
import React, { useState, useEffect } from "react";
import {
  Document,
  StyleSheet,
  Page,
  Text,
  View,
  PDFViewer,
  Image,
} from "@react-pdf/renderer";
import { useParams } from "react-router-dom";

//import translation function for language translation
import { useTranslation } from "react-i18next";

//import api requiremnts
import * as url from "urlhelpers/UrlHelper";
import { getData } from "utils/Gateway";

const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    padding: 30,
    fontSize: 12,
    fontFamily: "Helvetica",
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 20,
  },
  logo: {
    width: 100,
    height: 40,
  },
  invoiceTitle: {
    fontSize: 24,
    textAlign: "center",
    marginBottom: 20,
  },
  clientInfo: {
    marginBottom: 20,
  },
  invoiceDetails: {
    marginBottom: 20,
  },
  table: {
    display: "table",
    width: "100%",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableRow: {
    flexDirection: "row",
    width: "100%",
  },

  tableColSm: {
    width: "5%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center",
  },
  tableCol: {
    width: "10%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center",
  },
  tableColMd: {
    width: "15%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center",
  },
  tableColBg: {
    width: "35%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center",
  },

  totalSection: {
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
    borderTopWidth: 1,
    paddingTop: 8,
    marginTop: 8,
  },
  totalRight: {
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
    paddingTop: 8,
    marginTop: 8,
  },
  totalLeft: {
    flexDirection: "row",
    alignItems: "center",
    paddingTop: 8,
    marginTop: 8,
  },
});

const InvoicePDF = () => {
  const { t } = useTranslation(); //for translation

  const params = useParams();

  const [salesOrderData, setSalesOrderData] = useState("");
  const [salesOrderItems, setSalesOrderItems] = useState([]);

  const [responseReceived, setResponseReceived] = useState(false);

  //get sales order details
  const getSalesOrderDetails = async (salesOrderId) => {
    try {
      let requestUrl =
        url.API_BASEURL + url.API_GET_SALES_ORDER_DETAILS + `/${salesOrderId}`;

      const response = await getData(requestUrl);

      console.log("resp in sales order details ----->", response);
      if (response.status) {
        setSalesOrderData(response.data);
        setSalesOrderItems(
          response.data ? response.data.salesorderitemsextended : []
        );
        setResponseReceived(true);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    if (params.id && responseReceived === false) {
      //console.log('sales order params id', params.id)
      getSalesOrderDetails(params.id);
    }

    console.log("params.id", params.id);
  });

  return (
    <div style={{ height: "100vh", display: "flex" }}>
      {/* Display the PDF in a viewer */}
      <PDFViewer style={{ width: "100%", height: "100%" }}>
        <Document>
          <Page size="A4" style={styles.page}>
            <View style={styles.header}>
              <Image
                src="data:image/png;base64,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"
                style={styles.logo}
              />
              <Text>Order Id : {salesOrderData.invoiceid}</Text>
            </View>
            <Text style={styles.invoiceTitle}>Invoice</Text>

            <View style={styles.clientInfo}>
              <Text>{salesOrderData?.clientfullname}</Text>
              <Text>
                {salesOrderData?.client?.address} {salesOrderData?.client?.city}
              </Text>
              <Text>
                {salesOrderData?.client?.country},
                {salesOrderData?.client?.zipcode}
              </Text>
            </View>

            <View style={styles.invoiceDetails}>
              <Text>Date: {salesOrderData?.createddate}</Text>
            </View>
            <View style={styles.invoiceDetails}>
              <Text>Due Date: {salesOrderData?.duedate}</Text>
            </View>

            <View style={styles.table}>
              <View style={styles.tableRow}>
                <Text style={styles.tableColSm}>ID</Text>
                <Text style={styles.tableColMd}>ReserveId</Text>
                <Text style={styles.tableColBg}>Description</Text>
                <Text style={styles.tableColMd}>Date</Text>
                <Text style={styles.tableCol}>Cost</Text>
                <Text style={styles.tableCol}>Tax%</Text>
                <Text style={styles.tableCol}>Amount</Text>
              </View>
              {/* Invoice Items */}

              {salesOrderItems.map((salesOrderItem, index) => {
                return (
                  <View style={styles.tableRow} key={index}>
                    <Text style={styles.tableColSm}>{index + 1}</Text>
                    <Text style={styles.tableColMd}>
                      {salesOrderItem?.reservation?.reserveid}
                    </Text>
                    <Text style={styles.tableColBg}>
                      {salesOrderItem?.description}
                    </Text>
                    <Text style={styles.tableColMd}>
                      {salesOrderItem?.reservedate}
                    </Text>
                    <Text style={styles.tableCol}>
                      €{salesOrderItem?.totalprice}
                    </Text>
                    <Text style={styles.tableCol}>
                      {salesOrderItem?.taxpercent}
                    </Text>
                    <Text style={styles.tableCol}>
                      €{salesOrderItem?.totalprice}
                    </Text>
                  </View>
                );
              })}

              {/* Add more rows as needed */}
            </View>

            {/* Footer */}
            <View style={styles.totalSection}>
              <Text>Total Amount: € {salesOrderData?.totalpaybleprice}</Text>
            </View>
            <View style={styles.totalRight}>
              <Text>Total Tax: € 0 </Text>
            </View>
            <View style={styles.totalRight}>
              <Text>Payable Amount: € {salesOrderData?.totalpaybleprice} </Text>
            </View>

            <View style={styles.totalLeft}>
              <Text>Comments: {salesOrderData?.message} </Text>
            </View>
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
};

export default InvoicePDF;
